import {
  EVoyageEnemyShipCommand,
  EVoyageEnemyShipType,
} from '../multi/voyageMessageEnemyShipCommand'
import { voyageMessageEnemyShipCommand } from '../multi/voyageMessageEnemyShipCommand-sidecar'

export function run_enemyShip() {
  voyageMessageEnemyShipCommand.sendMessageAndImmediatelyExecute({
    command: EVoyageEnemyShipCommand.Create,
    type: EVoyageEnemyShipType.Hammerhead,
  })
}
